import { render, staticRenderFns } from "./EmployeeDocument.vue?vue&type=template&id=2acec89c&"
import script from "./EmployeeDocument.vue?vue&type=script&lang=js&"
export * from "./EmployeeDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports